import {
  HeatmapLowWearTimeGCBG,
  HeatmapLowWearTimeBG,
  HeatmapLowWearTimeGCLFBG,
  NotJoinedBG,
  CombinedHeatmapLegend,
} from '../../asset/image'
import {selectTheme} from '../../store'
import {AdherenceType} from '..'

export const HeatMapLegend = (props: {adherenceType?: string}) => {
  const {color, fontSize} = selectTheme()
  const {adherenceType} = props
  return (
    <>
      {adherenceType !== AdherenceType.Overview && (
        <div
          css={{
            position: 'sticky',
            bottom: 0,
            width: '100%',
            minHeight: 48,
            height: 48,
            borderRadius: 5,
            backgroundColor: color.surface.hover.hoverGreyBg,
            padding: '0 16px',
            display: 'flex',
            alignItems: 'center',
            gap: 40,
          }}>
          {/* legend for different rage of wearTime */}
          <div
            css={{
              width: 194,
              display: 'flex',
              flexDirection: 'column',
              gap: 4,
            }}>
            <div
              css={{
                display: 'grid',
                gridTemplateColumns: 'repeat(6, 1fr)',
                width: '100%',
                height: 8,
                borderRadius: 2,
                border: `1px solid ${color.border.dark}`,
                overflow: 'hidden',
              }}>
              <div
                css={{
                  backgroundImage: `url(${
                    adherenceType === AdherenceType.GarminConnectWearTime
                      ? HeatmapLowWearTimeGCBG
                      : adherenceType === AdherenceType.GarminDirectBbiDigest
                        ? HeatmapLowWearTimeBG
                        : HeatmapLowWearTimeGCLFBG
                  })`,
                  backgroundSize: 'cover',
                }}
              />
              <div
                css={{
                  backgroundColor:
                    adherenceType === AdherenceType.GarminConnectWearTime
                      ? color.heatmap.gc._1
                      : adherenceType === AdherenceType.GarminDirectBbiDigest
                        ? color.heatmap.lf._1
                        : color.heatmap.mix._1,
                }}
              />
              <div
                css={{
                  backgroundColor:
                    adherenceType === AdherenceType.GarminConnectWearTime
                      ? color.heatmap.gc._2
                      : adherenceType === AdherenceType.GarminDirectBbiDigest
                        ? color.heatmap.lf._2
                        : color.heatmap.mix._2,
                }}
              />
              <div
                css={{
                  backgroundColor:
                    adherenceType === AdherenceType.GarminConnectWearTime
                      ? color.heatmap.gc._3
                      : adherenceType === AdherenceType.GarminDirectBbiDigest
                        ? color.heatmap.lf._3
                        : color.heatmap.mix._3,
                }}
              />
              <div
                css={{
                  backgroundColor:
                    adherenceType === AdherenceType.GarminConnectWearTime
                      ? color.heatmap.gc._4
                      : adherenceType === AdherenceType.GarminDirectBbiDigest
                        ? color.heatmap.lf._4
                        : color.heatmap.mix._4,
                }}
              />
              <div
                css={{
                  backgroundColor:
                    adherenceType === AdherenceType.GarminConnectWearTime
                      ? color.heatmap.gc._5
                      : adherenceType === AdherenceType.GarminDirectBbiDigest
                        ? color.heatmap.lf._5
                        : color.heatmap.mix._5,
                }}
              />
            </div>
            <div
              css={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 8,
              }}>
              <span
                css={{
                  color: color.textIcon.secondary,
                  fontSize: fontSize.h8,
                  width: 24,
                  textAlign: 'center',
                }}>
                4hr
              </span>
              <span
                css={{
                  color: color.textIcon.secondary,
                  fontSize: fontSize.h8,
                  width: 24,
                  textAlign: 'center',
                }}>
                8hr
              </span>
              <span
                css={{
                  color: color.textIcon.secondary,
                  fontSize: fontSize.h8,
                  width: 24,
                  textAlign: 'center',
                }}>
                12hr
              </span>
              <span
                css={{
                  color: color.textIcon.secondary,
                  fontSize: fontSize.h8,
                  width: 24,
                  textAlign: 'center',
                }}>
                16hr
              </span>
              <span
                css={{
                  color: color.textIcon.secondary,
                  fontSize: fontSize.h8,
                  width: 24,
                  textAlign: 'center',
                }}>
                20hr
              </span>
            </div>
          </div>
          {/* legend for no data */}
          <div
            css={{
              display: 'flex',
              flexDirection: 'column',
              gap: 4,
            }}>
            <div
              css={{
                width: 50,
                height: 8,
                border: `1px solid ${color.border.default}`,
                backgroundColor: color.surface.white,
                borderRadius: 2,
              }}
            />
            <span css={{fontSize: fontSize.h8, color: color.textIcon.secondary}}>
              {adherenceType === AdherenceType.GCLFCombined
                ? 'No data (HR/BBI)'
                : `No ${adherenceType === AdherenceType.GarminConnectWearTime ? 'HR' : 'BBI'} data`}
            </span>
          </div>
          {/* legend for haven't sync yet */}
          <div
            css={{
              display: 'flex',
              flexDirection: 'column',
              gap: 4,
            }}>
            <div
              css={{
                width: 50,
                height: 8,
                border: `1px solid ${color.border.default}`,
                borderRadius: 2,
                backgroundImage: `url(${NotJoinedBG})`,
                backgroundSize: 'cover',
              }}
            />
            <span css={{fontSize: fontSize.h8, color: color.textIcon.secondary}}>Not joined yet</span>
          </div>
          {/* legend for combined wear time */}
          {adherenceType === AdherenceType.GCLFCombined && <img height={30} src={CombinedHeatmapLegend} />}
        </div>
      )}
    </>
  )
}
